/**
 * @author Marco Visin
 * @date 2025-05-30
 */

export type InNotesResourceType =
	| 'contact'
	| 'note'
	| 'job'
	| 'status'
	| 'tag'
	| 'user';

export type InNotesOperationType =
	| 'create'
	| 'get'
	| 'getAll'
	| 'update'
	| 'delete';

export interface IContact {
	id?: string;
	name?: string;
	linkedin_key?: string;
	linkedin_user?: string;
	location?: string;
	current_company?: string;
	picture_url?: string;
	tags?: string[];
	status_id?: string;
	contact_details?: IContactDetail[];
	created_at?: string;
	updated_at?: string;
}

export interface IContactDetail {
	type: 'email' | 'phone';
	value: string;
	label?: string | null;
}

export interface INote {
	id?: string;
	user_id?: string;
	ext_id?: string;
	ext_table_name?: string;
	text?: string;
	visibility?: 'private' | 'public';
	flagColor?: string;
	created_at?: string;
	updated_at?: string;
}

export interface IJob {
	id?: string;
	ext_id?: string;
	name?: string;
	company_name?: string;
	location?: string;
	description?: string;
	remote_setting?: string;
	picture_url?: string;
	company_url?: string;
	status_id?: string;
	tags?: string[];
	created_at?: string;
	updated_at?: string;
}

export interface IStatus {
	id?: string;
	user_id?: string;
	name?: string;
	type?: 'contact' | 'job';
	created_at?: string;
}

export interface IUser {
	id?: string;
	name?: string;
	username?: string;
	email?: string;
	status?: 'free' | 'premium' | 'admin';
	subscription_id?: string;
	created_at?: string;
	updated_at?: string;
}

export interface ITag {
	id?: string;
	name?: string;
	user_id?: string;
	count?: number;
}
